import {NgModule} from '@angular/core';
import {CoreModule} from '../core/core.module';
import {ClientenOverzichtRegioverantwoordelijkeComponent} from './clienten/overzicht-regioverantwoordelijke/clienten-overzicht-regioverantwoordelijke.component';
import {UpsertClientComponent} from './upsert-client/upsert-client.component';
import {ZoneModule} from '../zone/zone.module';
import {ClientComponent} from './client/client.component';
import {AdresPipe} from './pipe/adres.pipe';
import {GemeentePipe} from './pipe/gemeente.pipe';
import {StraatPipe} from './pipe/straat.pipe';
import {ClientHeaderComponent} from './client-header/client-header.component';
import {ClientenFilterComponent} from './clienten/filter/clienten-filter.component';
import {ClientnummerInputComponent} from './clientnummer-selector/input/clientnummer-input.component';
import {ClientnummerQrScanComponent} from './clientnummer-selector/qr/clientnummer-qr-scan.component';
import {ClientnummerSelectorComponent} from './clientnummer-selector/clientnummer-selector.component';
import {ClientDienstenBeheerComponent} from './client-diensten-beheer/client-diensten-beheer.component';
import {DienstModule} from '../dienst/dienst.module';
import {ClientTaakTypeComponent} from './client-diensten-beheer/taaktype/client-taak-type.component';
import {ClientCategorieComponent} from './client-diensten-beheer/categorie/client-categorie.component';
import {ClientDienstComponent} from './client-diensten-beheer/dienst/client-dienst.component';
import {ClientDienstenComponent} from './client-diensten/client-diensten.component';
import {TakenListComponent} from './client-diensten/taken-list/taken-list.component';
import {ClientenOverzichtTherapeutComponent} from './clienten/overzicht-therapeut/clienten-overzicht-therapeut.component';
import {ClientFicheBeheerComponent} from './client-fiche/client-fiche-beheer/client-fiche-beheer.component';
import {ClientFicheComponent} from './client-fiche/client-fiche.component';
import {ActiviteitModule} from '../activiteit/activiteit.module';
import {ClientDienstenPipe} from './client-diensten.pipe';

@NgModule({
  declarations: [
    ClientenFilterComponent,
    ClientnummerInputComponent,
    ClientnummerQrScanComponent,
    ClientnummerSelectorComponent,
    ClientenOverzichtRegioverantwoordelijkeComponent,
    ClientenOverzichtTherapeutComponent,
    UpsertClientComponent,
    ClientComponent,
    AdresPipe,
    GemeentePipe,
    StraatPipe,
    ClientDienstenPipe,
    ClientHeaderComponent,
    ClientDienstenComponent,
    TakenListComponent,
    ClientDienstenBeheerComponent,
    ClientFicheComponent,
    ClientFicheBeheerComponent,
    ClientDienstComponent,
    ClientTaakTypeComponent,
    ClientCategorieComponent,
  ],
  imports: [
    CoreModule,
    ZoneModule,
    DienstModule,
    ActiviteitModule,
  ],
  exports: [
    ClientenOverzichtRegioverantwoordelijkeComponent,
    ClientenOverzichtTherapeutComponent,
    UpsertClientComponent,
    ClientComponent,
    ClientDienstenPipe,
    ClientHeaderComponent,
    ClientnummerInputComponent,
    ClientnummerSelectorComponent,
    ClientDienstenComponent,
    ClientDienstenBeheerComponent,
    ClientFicheComponent,
    ClientFicheBeheerComponent,
  ],
})
export class ClientModule {
}
